import React from 'react';
import { Tooltip } from 'antd';
import UKFlag from 'src/assets/img/en.svg';
import './style.scss';
import { useTranslation } from 'react-i18next';

/**
 * LanguageFlagList component.
 *
 * @param {Object} props - Props for the LanguageFlagList component.
 * @param {string} props.englishLevel - The English level.
 * @returns {JSX.Element} The LanguageFlagList component.
 * @example
 *  <LanguageFlagList englishLevel={'C1 - Advanced'} />
 */
function LanguageFlagList({ englishLevel }) {
    const { t } = useTranslation();

    return (
        <div className="language-flag-list">
            <div>
                <Tooltip title={t("englishLevel")}>
                    <img src={UKFlag} alt={t("englishFlag")}/>
                </Tooltip>
                <span tabIndex={0} aria-label={`${t('englishLevel')} ${englishLevel}`} >
                    {englishLevel}
                </span>
            </div>
        </div>
    );
}

LanguageFlagList.defaultProps = {
    englishLevel: ''
}

export default LanguageFlagList;